/**
 * KDButton — Theme-aware button wrapper
 */

import { forwardRef } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";

const KDButtonRoot = styled(Button)(({ theme, ownerState }) => {
  const { palette, borders } = theme;
  const { color, variant, size, circular, iconOnly } = ownerState;

  const paletteColor = palette[color] || palette.primary;

  const baseStyles = {
    borderRadius: circular ? borders.borderRadius.full : borders.borderRadius.md,
    ...(iconOnly && {
      minWidth: size === "small" ? pxToRem(28) : size === "large" ? pxToRem(44) : pxToRem(36),
      width: size === "small" ? pxToRem(28) : size === "large" ? pxToRem(44) : pxToRem(36),
      height: size === "small" ? pxToRem(28) : size === "large" ? pxToRem(44) : pxToRem(36),
      padding: 0,
    }),
  };

  if (variant === "gradient") {
    const gradient = palette.gradients?.[color];
    return {
      ...baseStyles,
      background: gradient
        ? `linear-gradient(195deg, ${gradient.main}, ${gradient.state})`
        : paletteColor.main,
      color: "#fff",
      "&:hover": {
        background: gradient
          ? `linear-gradient(195deg, ${gradient.main}, ${gradient.state})`
          : paletteColor.focus || paletteColor.dark,
      },
    };
  }

  return baseStyles;
});

const KDButton = forwardRef(
  ({ color = "primary", variant = "contained", size = "medium", circular, iconOnly, children, ...rest }, ref) => (
    <KDButtonRoot
      {...rest}
      ref={ref}
      variant={variant === "gradient" ? "contained" : variant}
      size={size}
      ownerState={{ color, variant, size, circular, iconOnly }}
    >
      {children}
    </KDButtonRoot>
  )
);

KDButton.displayName = "KDButton";

export default KDButton;
